var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94812 13.875C1.48505 13.875 1.0931 13.7146 0.772266 13.3937C0.451432 13.0729 0.291016 12.681 0.291016 12.2179V1.7821C0.291016 1.31903 0.451432 0.927083 0.772266 0.60625C1.0931 0.285417 1.48505 0.125 1.94812 0.125H16.0506C16.5136 0.125 16.9056 0.285417 17.2264 0.60625C17.5473 0.927083 17.7077 1.31903 17.7077 1.7821V12.2179C17.7077 12.681 17.5473 13.0729 17.2264 13.3937C16.9056 13.7146 16.5136 13.875 16.0506 13.875H1.94812ZM8.99935 7.51127L16.3327 2.82206L16.1917 1.5L8.99935 6.08333L1.80695 1.5L1.66602 2.82206L8.99935 7.51127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail1);
export default __webpack_public_path__ + "static/media/mail (1).e56c5ec79ac07ec6a54213d36e938bf6.svg";
export { ForwardRef as ReactComponent };